import React from 'react';
import { FaInstagram, FaFacebookF, FaTiktok, FaWhatsapp, FaYoutube } from 'react-icons/fa';
import * as S from './Footer.styles';
import { useTranslation } from '../i18n';

const Footer = () => {
  const t = useTranslation();

  return (
    <S.Footer>
      <S.SectionTitle>Conectate con nosotros</S.SectionTitle>
      <S.SocialLinks>
        <S.SocialLink 
          href="https://www.instagram.com/fe_en_juego/" 
          target="_blank" 
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <FaInstagram />
        </S.SocialLink>
        <S.SocialLink 
          href="https://www.facebook.com/feenjuego" 
          target="_blank" 
          rel="noopener noreferrer"
          aria-label="Facebook"
        >
          <FaFacebookF />
        </S.SocialLink>
        <S.SocialLink 
          href="https://www.tiktok.com/@fe_en_juego" 
          target="_blank" 
          rel="noopener noreferrer"
          aria-label="TikTok"
        >
          <FaTiktok />
        </S.SocialLink>
        <S.SocialLink
          href="https://wa.me/59895454544"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp"
        >
          <FaWhatsapp />
        </S.SocialLink>
        <S.SocialLink
          href="https://www.youtube.com/@fe_en_juego"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="YouTube"
        >
          <FaYoutube />
        </S.SocialLink>
      </S.SocialLinks>
      <S.FooterText>{t('footer.copyright')}</S.FooterText>
    </S.Footer>
  );
};

export default Footer;
